<template>

  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class=" bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="text-center">
                <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.webp">
              </div>
            </div>
          </div>
          <div class="container ">
            <div class="row g-2 text-center">
              <div class="text-uppercase" style="font-weight: bold; font-color: red">{{ $t('message.error_generic_titolo') }}</div>

              <p class="px-5 mb-5">{{ $t('message.error_generic_text') }}</p>
              <br>
              <div class="col-lg-4 col-md-6 text-center"><button type="submit" class="btn styleBtn mb-3 endBtn" @click="nuovaRichiesta"> Inserisci una nuova richiesta</button></div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
</template>

<script>

import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import {useStore} from "vuex";

export default {
  name: "ErroreInserimento",
  setup(){
    const store = useStore();
    return {
      pulisciStato: () => {
        store.dispatch('volo/commitPulisciStato');
        store.dispatch('compilazione/commitPulisciStato');
        store.dispatch('passeggeri/commitPulisciStato');
      }
    }
  },
  components:{
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  methods:{
    inizia(){
      this.pulisciStato();
      this.$router.push('/customers/it/flightsub/');
    }
  },
  mounted() {
    window.scrollTo(0,0);
  },
}
</script>

<style scoped>

</style>